import React from "react";
import { Container } from "../Common__style/Micro-style";
import styled from "styled-components";



const CopyrightBody = styled.div`
background-color: rgba(23, 24, 25, 1);
color: rgb(255,255,255);
`

const CopyrightText = styled.div`
height: 3.75rem;
text-align: center;
line-height: 3.75rem;
font-size: 0.6rem;
`


export default function Copyright() {
   return (
      <CopyrightBody>
         <Container>
            <CopyrightText>© 2017 Konstruct Inc. Designed by Jane Kathryn Teo</CopyrightText>
         </Container>
      </CopyrightBody>
   )
}